<template>
  <span
    class="remove-resource-btn"
    @mouseenter="toggleHover"
    @mouseleave="toggleHover"
    @click="removeResource"
    @keypress="removeResource"
    tabindex="0">
    <i class="fa fa-lg fa-times" aria-hidden="true"/>
  </span>
</template>

<script >
export default {
  name: 'RemoveResourceButton',
  data() {
    return {
      isHovered: false
    }
  },
  computed: {},
  props: {
    resourceId: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    collectionId: {
      type: String,
      required: true
    }
  },
  methods: {
    removeResource: function(evt) {
      evt.preventDefault()
      if (confirm(`Are you sure you want to delete this ${this.type} from your library?`)) {
        this.$store.dispatch('library/deleteResource', {
          uuid: this.resourceId,
          type: this.type,
          collection: this.collectionId
        })
      }
    },
    toggleHover: function() {
      this.isHovered = !this.isHovered
    }
  }
}
</script>

<style scoped lang="less">
.remove-resource-btn {
  position: absolute;
  top: 4px;
  right: 6px;
  display: inline-block;
  padding: 1px 3px;
  border-radius: 3px;
  color: #b94a48;
  font-size: 12px;
  z-index: 1;
  &:hover, &:focus {
    color: white;
    background-color: #b94a48;
    cursor: pointer;
  }
}
</style>
